import { component } from "picoapp";

export const reviewsSummary = component((node) => {
  const readMoreReviewsButton = node.querySelector(
    "#read-more-reviews-container button"
  );
  const readMoreReviewsButtonContainer = node.querySelector(
    "#read-more-reviews-container"
  );
  const reviewsCount =
    document.querySelector<HTMLSpanElement>("#reviews-count");
  const reviewsWidget = document.querySelector(".yotpo-main-widget");

  if (!reviewsWidget) {
    readMoreReviewsButtonContainer.classList.add("hidden");
  }

  const populateTotalReviewsText = async () => {
    const yotpoId = reviewsCount.dataset.yotpoId;
    const productId = reviewsCount.dataset.productId;
    if (yotpoId && productId) {
      const { response } = await fetch(
        `https://api.yotpo.com/products/${yotpoId}/${productId}/bottomline`
      )
        .then((res) => res.json())
        .catch((e) => console.error(e));

      if (response) {
        const totalReviews = response.bottomline?.total_reviews;
        reviewsCount.innerHTML = `(${totalReviews.toLocaleString()})`;
      }
    }
  };

  if (reviewsCount) {
    requestIdleCallback(() => populateTotalReviewsText());
  }

  const handleReadMoreReviewsButtonClick = function (e) {
    e.preventDefault();

    window.scrollTo({
      behavior: "smooth",
      top:
        reviewsWidget.getBoundingClientRect().top -
        document.body.getBoundingClientRect().top,
    });
  };

  readMoreReviewsButton.addEventListener(
    "click",
    handleReadMoreReviewsButtonClick
  );

  return () => {
    readMoreReviewsButton.removeEventListener(
      "click",
      handleReadMoreReviewsButtonClick
    );
  };
});
